'use client';

export { default } from './Zoom';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Zoom/index.js
// module id = 511
// module chunks = 22